<section id="login" [className]="'login ' + (cssClass ? cssClass : 'section-auth')">
  <div class="container">
    <div class="row">
      <div class="auth-wrapper">

        <!-- LEFT BRAND / HERO PANEL -->
        <aside class="auth-hero">
          <!-- <div class="brand">
            <div class="brand-logo">AIO</div>
            <div class="brand-name">All-In-One Invoice</div>
          </div> -->

          <h1 class="hero-heading">
            Smarter invoicing in minutes.
          </h1>

          <p class="hero-text">
            Send professional invoices, track payments, and keep your cashflow organized from a single, intuitive
            dashboard.
          </p>

          <div class="hero-badges">
            <span class="hero-badge">No credit card required</span>
            <span class="hero-badge">Secure & encrypted</span>
            <span class="hero-badge">Multi-currency ready</span>
          </div>

          <div class="hero-highlight-card">
            <div>
              <div class="hero-metric">15k+</div>
              <div class="hero-metric-label">
                Invoices generated / month
              </div>
            </div>

            <div class="hero-checklist">
              <span>• Auto-calculate taxes and discounts</span>
              <span>• Save client profiles once, reuse forever</span>
            </div>
          </div>
        </aside>

        <!-- RIGHT LOGIN PANEL -->
        <main class="auth-main">
          <header class="auth-header">
            <div class="auth-kicker">Welcome back</div>
            <h2 class="auth-title">Log in to your account</h2>
            <p class="auth-subtitle">
              Access your invoices, clients, and payment history in one place.
            </p>
          </header>

          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="off">
            <div class="field-group">
              <label class="field-label" for="email">
                Email address <span>*</span>
              </label>
              <input class="form-control" type="email" id="email" formControlName="email"
                placeholder="Enter your email*"
                [class.is-invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched" />
            </div>

            <div class="field-group">
              <label class="field-label" for="password">
                Password <span>*</span>
              </label>

              <div class="field-control">
                <input class="form-control" type="password" id="password" formControlName="password"
                  placeholder="Enter your password*"
                  [class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" />
                <!-- <span class="password-toggle">Show</span> -->
              </div>
            </div>

            <div class="auth-options">
              <label class="checkbox">
                <input type="checkbox" formControlName="remember" />
                <span>Keep me signed in</span>
              </label>

              <a routerLink="/auth/forgot-password" class="link-accent" (click)="forgotPassword.emit()">
                Forgot password?
              </a>
            </div>

            <div class="auth-actions">
              <button type="submit" class="btn btn-get-started w-100" [disabled]="loginForm.invalid">
                Log in
              </button>
            </div>
          </form>

          <div class="auth-footer">
            New to AllInOneInvoices?
            <a routerLink="/auth/sign-up" class="link-accent" (click)="createAccount.emit()">
              Create an account
            </a>
          </div>
        </main>

      </div>
    </div>
  </div>
</section>